module.exports = __webpack_public_path__ + "img/farming_37.e5db5dda.png";